import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "w-8" }, null, -1)
const _hoisted_2 = { class: "flex-1 text-center flex items-center justify-center" }
const _hoisted_3 = {
  key: 0,
  class: "w-8"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")

  return (_openBlock(), _createBlock("div", {
    class: ['app-nav-alert', _ctx.classes]
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_BalIcon, {
        name: _ctx.iconName,
        class: "mr-4"
      }, null, 8, ["name"]),
      _createVNode("span", null, _toDisplayString(_ctx.alert.label), 1)
    ]),
    (!_ctx.alert.persistant)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_BalIcon, {
            name: "x",
            class: "cursor-pointer",
            onClick: _ctx.handleClose
          }, null, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}